import { supabase } from '../supabaseClient';

/**
 * Teams 支援的事件類型（code 控制）
 * UI 用這個列表來產生事件 checkbox
 */
export const TEAMS_SUPPORTED_EVENTS = [
  { value: 'ticket_assigned', label: '被指派工作項目' },
  { value: 'mentioned', label: '留言中被 @mention' },
  { value: 'work_item_comment', label: '追蹤的工作項目有新留言' },
  { value: 'deliverable_handoff', label: '收到交付項目交棒' },
];

/**
 * 取得用戶的所有個人 webhook
 */
export const getMyWebhooks = async (userId) => {
  try {
    const { data, error } = await supabase
      .from('webhook_channels')
      .select('*')
      .eq('scope_type', 'user')
      .eq('scope_id', userId)
      .order('created_at', { ascending: true });

    if (error) throw error;
    return { data: data || [], error: null };
  } catch (error) {
    console.error('Error fetching webhooks:', error);
    return { data: null, error };
  }
};

/**
 * 新增個人 webhook
 */
export const addWebhook = async ({ user_id, webhook_url, label, subscribed_events = null }) => {
  try {
    const { data, error } = await supabase
      .from('webhook_channels')
      .insert({
        scope_type: 'user',
        scope_id: user_id,
        channel_type: 'teams',
        webhook_url,
        label: label || null,
        subscribed_events,
        created_by: user_id,
      })
      .select()
      .single();

    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('Error adding webhook:', error);
    return { data: null, error };
  }
};

/**
 * 更新 webhook
 */
export const updateWebhook = async (id, updates) => {
  try {
    const updateData = { updated_at: new Date().toISOString() };
    if (updates.label !== undefined) updateData.label = updates.label;
    if (updates.webhook_url !== undefined) updateData.webhook_url = updates.webhook_url;
    if (updates.subscribed_events !== undefined) updateData.subscribed_events = updates.subscribed_events;
    if (updates.is_active !== undefined) updateData.is_active = updates.is_active;

    const { data, error } = await supabase
      .from('webhook_channels')
      .update(updateData)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('Error updating webhook:', error);
    return { data: null, error };
  }
};

/**
 * 刪除 webhook
 */
export const deleteWebhook = async (id) => {
  try {
    const { error } = await supabase
      .from('webhook_channels')
      .delete()
      .eq('id', id);

    if (error) throw error;
    return { error: null };
  } catch (error) {
    console.error('Error deleting webhook:', error);
    return { error };
  }
};

/**
 * 測試 webhook — 發送測試 Adaptive Card
 * @returns {{ success: boolean, error?: string }}
 */
export const testWebhook = async (webhookUrl, targetEmail) => {
  try {
    const card = {
      type: 'AdaptiveCard',
      $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
      version: '1.4',
      ...(targetEmail ? { targetEmail } : {}),
      body: [
        {
          type: 'TextBlock',
          text: '【Sonice Webhook 測試成功】',
          weight: 'Bolder',
          size: 'Medium',
        },
        {
          type: 'TextBlock',
          text: '此為測試訊息，確認 Webhook URL 設定正確。',
          wrap: true,
        },
        ...(targetEmail
          ? [{
              type: 'TextBlock',
              text: `👤 ${targetEmail}`,
              size: 'Small',
              isSubtle: true,
            }]
          : []),
        {
          type: 'TextBlock',
          text: `⏰ ${new Date().toLocaleString('zh-TW', { timeZone: 'Asia/Taipei' })}`,
          size: 'Small',
          isSubtle: true,
        },
      ],
    };

    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(card),
    });

    if (!response.ok) {
      return { success: false, error: `HTTP ${response.status}` };
    }

    return { success: true };
  } catch (error) {
    console.error('Error testing webhook:', error);
    return { success: false, error: error.message };
  }
};
